import { Controller } from '@hotwired/stimulus'
import { throttle } from 'throttle-debounce'
import { MicrophoneManager } from './microphone_manager.js'

export default class extends Controller {
  static targets = ['startIcon', 'stopIcon', 'loadingIcon', 'microphoneFillContainer', 'microphoneFill']

  isActive = false
  audioLevelUnsubscribe = null

  connect() {
    this.showInactive()
  }

  disconnect() {
    this.#stopAudioLevelMonitoring()
  }

  showLoading() {
    this.#hideAll()
    this.loadingIconTarget.classList.remove('hidden')
  }

  showActive() {
    this.#hideAll()
    this.stopIconTarget.classList.remove('hidden')
    this.element.classList.add('t-btn-danger')
    this.isActive = true
    this.#startAudioLevelMonitoring()
  }

  showInactive() {
    this.#hideAll()
    this.startIconTarget.classList.remove('hidden')
    this.isActive = false
    this.#stopAudioLevelMonitoring()
  }

  // Private methods
  #hideAll() {
    this.startIconTarget.classList.add('hidden')
    this.stopIconTarget.classList.add('hidden')
    this.loadingIconTarget.classList.add('hidden')
    this.element.classList.remove('t-btn-danger')
  }

  #startAudioLevelMonitoring() {
    this.audioLevelUnsubscribe = MicrophoneManager.onAudioLevel((level) => {
      this.#updateWaveform(level)
    })
  }

  #stopAudioLevelMonitoring() {
    if (this.audioLevelUnsubscribe) {
      this.audioLevelUnsubscribe()
      this.audioLevelUnsubscribe = null
    }
    this.#resetWaveform()
  }

  #updateWaveform(level) {
    this.#updateMicrophoneFill(level)
  }

  #resetWaveform() {
    this.#resetMicrophoneFill()
  }

  #updateMicrophoneFill = throttle(20, (level) => {
    if (!this.hasMicrophoneFillContainerTarget) return

    const fillPercentage = Math.min(this.#scaleLevel(level), 100)
    const clipPath = `inset(${100 - fillPercentage}% 0 0 0)`
    this.microphoneFillContainerTarget.style.clipPath = clipPath
  })

  #scaleLevel(level) {
    const input = Math.max(level * 100, 0)

    if (input <= 7) {
      return 0
    } else if (input < 12) {
      return 20 + input
    } else if (input < 30) {
      return 30 + input
    } else if (input < 95) {
      return 40 + input
    } else {
      return 100
    }
  }

  #resetMicrophoneFill() {
    if (!this.hasMicrophoneFillContainerTarget) return
    this.microphoneFillContainerTarget.style.clipPath = 'inset(100% 0 0 0)'
  }
}
